/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-guided-tour-overlay {
  display: block;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  z-index: var(--ux-guided-tour-overlay-z-index, 800);
}
.ux-guided-tour-overlay.ux-guided-tour-overlay--ready {
  transition: opacity 0.2s ease-out;
}
.ux-guided-tour-overlay.ux-guided-tour-overlay--active {
  opacity: 1;
}
.ux-guided-tour-overlay__canvas {
  left: 0;
  opacity: 0.5;
  pointer-events: none;
  position: absolute;
  top: 0;
}
.ux-guided-tour-overlay__focus {
  pointer-events: none;
  position: absolute;
}
.ux-guided-tour-overlay__focus--highlight {
  box-shadow: 0 0 20px 5px var(--ux-guided-tour-overlay-glow-color);
  mix-blend-mode: screen;
}
.ux-guided-tour-overlay__focus--shadow {
  box-shadow: 0 0 20px 5px var(--ux-guided-tour-overlay-shadow-color);
}
.ux-guided-tour-overlay__buttons {
  margin-top: 20px;
  text-align: right;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  flex-wrap: wrap;
}
@media only screen and (min-width: 768px) {
  .ux-guided-tour-overlay__buttons {
    justify-content: flex-end;
  }
}
.ux-guided-tour-overlay__steps {
  color: #727272;
  font-size: 13px;
  line-height: 1;
  margin-bottom: 0.5em;
  margin-top: -0.5em;
}
.ux-guided-tour-overlay .ux-popover__container {
  max-width: calc(100vw - 40px);
}
.ux-guided-tour-overlay .ux-popover__overlay--opened {
  transition: opacity 200ms ease-out, transform 200ms ease-in-out;
}
.ux-guided-tour-overlay .ux-popover-panel {
  border-radius: var(--ux-guided-tour-overlay-border-radius);
}
.ux-guided-tour-overlay .ux-popover-panel {
  max-width: 100%;
  padding: 30px;
  width: 450px;
}
.ux-guided-tour-overlay .ux-popover-panel h4,
.ux-guided-tour-overlay .ux-popover-panel p {
  font-size: 16px;
  margin: 0 0 0.5em;
}
.ux-guided-tour-overlay .ux-popover-panel h4 {
  font-weight: 400;
}
.ux-guided-tour-overlay .ux-popover-panel .ux-button {
  height: var(--ux-button-min-height);
  min-height: var(--ux-button-min-height);
  padding-bottom: 0;
  padding-top: 0;
  vertical-align: top;
}
.ux-guided-tour-overlay .ux-popover-panel .ux-button:last-of-type {
  margin-left: 10px;
}

.ux-guided-tour-backdrop {
  display: block;
  height: auto;
  inset: 0;
  pointer-events: none;
  position: absolute;
  width: auto;
}
.ux-guided-tour-backdrop__blocker {
  pointer-events: auto;
  position: absolute;
}

.ux-guided-tour-progress {
  bottom: 0;
  height: 4px;
  left: 0;
  position: absolute;
  width: 100%;
}
.ux-guided-tour-progress__bar {
  background-color: var(--ux-guided-tour-progress-bar-color);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
}